'use strict';

const siteAlert = require('./alert');

module.exports = {
    hideMessages: function () {
        const $messages = $('.alert-message');

        if (!$messages.length) return;

        const url = new URL(window.location.href);
        url.searchParams.delete('redirectOfflineProduct');
        window.history.replaceState({}, '', url.toString());

        siteAlert.show({
            type: 'success',
            message: $messages.find('[role="alert"]').text().trim() || $messages.text().trim(),
            timeout: 3000
        });

        $messages.remove();
    }
};
